export default {
  primary: "#414aba",
  secondary: "#435A85",
  tertiary: "#E7ECF6",
  quaternary: "#32398F",
  pink: "#E00976",
};
